
import React, {useEffect, useState} from 'react';
import { isViewVisible } from "../../../../utils/ViewSettings";
import { Biscuit } from "../../../../utils";
import t from '../../../helpers/t';
import SalesBillingsSidebar from '../components/SalesBillingsSidebar';
import {paymentsActions, accumulatedInvoiceActions, useSelector, s3Actions} from 'inbooma-api';
import SalesBillingsList from './SalesBillingsList';
import AddSalesBillingsView from './AddSalesBillingsView';
import InboomaSubmenu from '../../../components/InboomaSubmenu';
import SortNav from '../../../components/SortNav';
import {$, _} from "../../../../../vendor";
import {S3Client} from "aws_js";
import * as FileSaver from "../../../../../vendor/FileSaver";
import {getApiHost} from "../../../../Sync";

const SalesBillingsView = (props) => {

    let language = Biscuit.get('user.lang').replace('-','_');
    const [initialized,setInitialized] = useState(false);
    const [filter,setFilter] = useState({});
    const [sort,setSort] = useState({
        sort: "created",
        direction: "desc"
    });
    const paginationLimit = 100;
    const [salesBillings,setSalesBillings] = useState([]);
    const [salesBillingsPending,setSalesBillingsPending] = useState(false);
    const _salesBillings = useSelector(state => state.accumulated_invoices_data.accumulatedInvoices);
    const _getDocument = useSelector(state => state.s3_data.getDocumentS3);
    const [getDocumentPending, setGetDocumentPending] = useState(false);

    useEffect(() => {
        if(_getDocument.success === '' || !getDocumentPending){
            return;
        }
        if(_getDocument.success === true){
            const blob = new Blob([_getDocument.data], { type: _getDocument.data.type });
            FileSaver.saveAs(blob, getDocumentPending.replace(/_/gi, ' '));
        } else {
            alert('Could not download: ' + _getDocument.data);
        }
        setGetDocumentPending(false);
    }, [_getDocument]);




    useEffect(() => {
        console.log("sales billings: ",_salesBillings);
                if (_salesBillings.success === "") {
                  return;
                }

                var dataLength = typeof _salesBillings.data.length === 'undefined' ? 0 : _salesBillings.data.length;

                if (salesBillingsPending === false && salesBillings.length == dataLength) return;
            
                if (_salesBillings.success === true) {

                    if (_salesBillings.pagination.current_page == 1) {
                        setSalesBillings([..._salesBillings.data]);
                    } else {
                        var clone = [...salesBillings];
                        clone.push(..._salesBillings.data);
                        setSalesBillings(clone);
                    }
                    //setPagination({..._salesBillings.pagination});
                } else {
                  console.log("Failed fetching wallets!");
                }
                setSalesBillingsPending(false);
    },[_salesBillings]);

    // remove item from local data (no refetch)
    const removeItem = (id) => {

      var clone = [...salesBillings];

      for (var i=0;i<salesBillings.length;i++) {
        if (salesBillings[i].id == id) {
          clone.splice(i,1);
          break;
        }
      }
      setSalesBillings(clone);
    };

    // add item to local data (no refetch)
    const addItem = (item) => {
      /*
console.log("add item: ", item);
      var clone = [...salesBillings];

      // to-do: find right index for item depending on sort params
      clone.push({...item});
      setSalesBillings(clone);*/

      setSalesBillingsPending(true);
    };

    const filterChangedHandle = (filter) => {

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = 1;

        props.dispatch(accumulatedInvoiceActions.getAccumulatedInvoices({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setSalesBillingsPending(true);
        setFilter(filter);
    };

    const onSortChangedHandle = (ev) => {
        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filter.limit !== 'undefined') {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }

            props.dispatch(accumulatedInvoiceActions.getAccumulatedInvoices({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setSalesBillingsPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key,value){
                key.classList.remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const showDelayedNotification = (msgType, itemId, apiMsg) => {
        // little delay necessary to make notifications visible (render of background must be done before)
        setTimeout( () => {
          if (msgType === 'success') {
                new Notification({
                  message : t('saved_${a}',{a:t('resource')},'capital')+' #'+ itemId,
                  duration : 5000,
                  type : 'success',
                  closeable : true,
                  icon : 'fi fi-check'
                });
              } else if (msgType === 'warning') {
                new Notification({
                  message : (typeof apiMsg !== 'undefined' && apiMsg !== null) ? t(apiMsg,null,'capital') : t('request_error',null,'capital'),
                  duration : 5000,
                  type : 'warning',
                  closeable : true,
                  icon : 'fi fi-x'
                });
              }
    
        },200);
    };

    const initialize = () => {

        props.dispatch(accumulatedInvoiceActions.getAccumulatedInvoices({
            token: Biscuit.get('token'),
            suffix: "",
            filter: {
                sort: sort.sort,
                direction: sort.direction,
                limit: paginationLimit,
                page: 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));  
        setSalesBillingsPending(true);      
        setInitialized(true);
    };

    const _readFile = (sales_billing) => {

        const file_name = sales_billing.name;

        props.dispatch(s3Actions.getDocumentS3({
            client_id: Biscuit.get('user.client_id'),
            type: 'SalesBilling',
            location: sales_billing.location_id,
            name: file_name,
            apiEntryPoint: getApiHost(),
            token: Biscuit.get('token')
        }));

        setGetDocumentPending(file_name);


        /*S3Client.getDocument(Number(Biscuit.get('user.client_id')),
            'SalesBilling',
            sales_billing.location_id,
            file_name,'https://api.inbooma.net/api')
            .then(data => {

                const blob = new Blob([data.Body], { type: data.ContentType });
                FileSaver.saveAs(blob, file_name.replace(/_/gi, ' '));

            })
            .catch((err) => {
                alert(`Error downloading file: ${err}`)
            });*/
    };

    if (initialized === false) initialize();

    const submenuItems = [
        {
          name: t('transactions',null,'capital'),
          link: 'finances/transactions',
          data_inb_val: t('transactions',null,'capital'),
          icon: 'fi fi-dollar',
          isActive: false,
          isAccessible: isViewVisible('transactions','finances')
        },{
          name: t('sales_billings',null,'capital'),
          link: 'finances/sales_billings',
          data_inb_val: t('sales_billings',null,'capital'),
          icon: 'fi fi-list',
          isActive: true,
          isAccessible: true
        },{
            name: t('payment_accounts',null,'capital'),
            link: 'finances/payment_accounts',
            data_inb_val: t('payment_accounts',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: false && isViewVisible('paymentAccounts','finances')
        },
        {
            name: t('insurances',null,'capital'),
            link: 'finances/insurances',
            data_inb_val: t('insurances',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: (Biscuit.get('user.is_superuser')  === 'true')
        },{
            name: t('admin transactions',null,'capital'),
            link: 'finances/admin_transactions',
            data_inb_val: t('admin transactions',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: (Biscuit.get('user.is_superuser')  === 'true')
        },{
            name: t('invoices',null,'capital'),
            link: 'invoices',
            data_inb_val: t('invoices',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: (Biscuit.get('user.is_superuser')  === 'true')
        }
    ];

    let tabs =[{
        name: t('service period',null,'capital'),
        smallWidth: 3,
        mediumWidth: 3,
        title: t('sort_by_${a}',{a:t('service period')},'capital'),
        canSort: true,
        sort: {
          direction: 'desc',
          data_inb_val: 'begin'
        }
      },{
        name: t('invoice_nbr',null,'capital'),
        smallWidth: 1,
        mediumWidth: 1,
        title: t('invoice_nbr',null,'capital'),
        canSort: true,
        sort: {
            direction: 'desc',
            data_inb_val: 'invoice_nbr_major'
        }
      },{
        name: t('invoice_date',null,'capital'),
        mediumWidth: 2,
        smallWidth: 2,
        title: t('invoice_date',null,'capital'),
        canSort: true,
        sort: {
            direction: 'desc',
            data_inb_val: 'created'
        }
      }, {
        name: t('paydate',null,'capital'),
        smallWidth: 2,
        mediumWidth: 2,
        title: t('paydate',null,'capital'),
        canSort: false,
    }, {
        name: t('paystatus',null,'capital'),
        smallWidth: 2,
        mediumWidth: 2,
        title: t('paystatus',null,'capital'),
        canSort: false,
      },{
        name: "",
        smallWidth: 1,
        mediumWidth: 1,
        title: "",
        canSort: false,
      },{
        name: "",
        smallWidth: 1,
        mediumWidth: 1,
        title: "",
        canSort: false,
      }
    ];

    return (
        <>
            <SalesBillingsSidebar
                dispatch={props.dispatch}
                heading={t('sales_billings',null,'capital')}
                filterChangedHandle={filterChangedHandle}/>
            <div id='inb-c-main' className='columns'>
                <InboomaSubmenu
                    tabs={submenuItems}
                    smallOnlyTitle={t('sales_billings',null,'capital')}
                />
                <SortNav
                    tabs={tabs}
                    listStyle="tight"
                    handler={onSortChangedHandle}/>
                <SalesBillingsList
                  salesBillings={salesBillings}
                  _readFile={_readFile}
                  removeItem={removeItem}
                  dispatch={props.dispatch}/>
            </div>
            {location.pathname.indexOf('sales_billings/add') >= 0 &&
                <AddSalesBillingsView
                    dispatch={props.dispatch}
                    addItem={addItem}
                    _readFile={_readFile}
                    showDelayedNotification={showDelayedNotification}/>
                }
        </>
    );
};

export default SalesBillingsView;